import React from 'react'
import PropTypes from 'prop-types'

import { CompactPicker } from 'react-color'

import FormGroup from '../components/FormGroup'

const ColorPickerField = (props) => {
    const {
        label, input, meta, description, isHorizontal, ...otherProps
    } = props
    const { name, value, onChange } = input
    const { error } = meta

    return (
        <FormGroup
            name={ name }
            label={ label }
            error={ error }
            description={ description }
            isHorizontal={ isHorizontal }
        >
            <br />
            <CompactPicker
                id={ name }
                onChangeComplete={ ({ hex }) => onChange(hex) }
                color={ value }
                { ...otherProps }
            />
        </FormGroup>
    )
}

ColorPickerField.propTypes = {
    label        : PropTypes.string,
    input        : PropTypes.object,
    meta         : PropTypes.object,
    description  : PropTypes.string,
    isHorizontal : PropTypes.bool
}

export default ColorPickerField
